import { render } from "./GuestOrders.vue?vue&type=template&id=2199bd2f"
import script from "./GuestOrders.vue?vue&type=script&lang=js"
export * from "./GuestOrders.vue?vue&type=script&lang=js"

import "./GuestOrders.vue?vue&type=style&index=0&id=2199bd2f&lang=css"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__